import { Vertical } from '@/types/verticals'
import { SearchMode } from '@/services/search-service/constants'

type SearchExamples = {
  [key in SearchMode]: string[]
}

type SearchExamplesByVertical = {
  [key in Vertical]: SearchExamples
}

const defaultLocationExamples: string[] = [
  '1905 Brooks St, Missoula, MT',
  '46.87222 -113.99305',
  'Wildlife Management Area',
  'Missoula, MT',
]

const defaultLandownerExamples: string[] = [
  'John Smith',
  'Bureau of Land Management',
  'Forest Service',
]

const defaultExamples: SearchExamples = {
  [SearchMode.Location]: defaultLocationExamples,
  [SearchMode.Landowner]: defaultLandownerExamples,
}

export const examplesByVertical: SearchExamplesByVertical = {
  [Vertical.Hunt]: defaultExamples,
  [Vertical.Offroad]: defaultExamples,
  [Vertical.Backcountry]: {
    [SearchMode.Location]: [
      '1905 Brooks St, Missoula, MT',
      '46.87222 -113.99305',
      'Arches National Park',
      'Missoula, MT',
    ],
    [SearchMode.Landowner]: defaultLandownerExamples,
  },
  [Vertical.Fish]: {
    [SearchMode.Location]: [
      'Leech Lake',
      '46.28779, -93.82102',
      'Rocky Reef',
      'Bait & Tackle',
    ],
    [SearchMode.Landowner]: defaultLandownerExamples,
  },
}
